import React, { Component } from "react";
import { observer } from "mobx-react";
import { fn_change_step } from "../../../../function/FnBodyStep";
import { fn_get_customer_pop, fn_set_customer_pop } from "../../../../function/FnBodyDetail";
import { fn_bridge_order_accept } from "../../../../function/FnPosBridge";
import { hungryPandaMobileOrderFg } from "utils/Utils"

@observer
class CustomerExpectTimeView extends Component {
    render() {

        const { rootStore } = this.props;
        const layerStore = rootStore.layerStore;
        return (
            <div className={"layer_comm layer_common_type " + (layerStore.getLayerCstExpectTimeView ? ' layer_open' : '')}>
                <div className="bg" />
                <div className="layer_content">
                    <div className="article_common_type">
                        <div className="section_tit_comm">
                            {
                                (hungryPandaMobileOrderFg(rootStore.viewStore.getOrderDetail.mobileOrderFg)) 
                                ? <h1>조리시간 선택</h1>
                                : <h1>고객 예상수령시간 선택</h1>
                            }
                        </div>
                        <div className="list_radio_time">
                            <label
                            ><input type="radio" name="time" checked={(fn_get_customer_pop(rootStore, "min1") === "Y") ? true : ""}
                                onChange={event => {
                                    rootStore.layerStore.setChangeCstTime('1');
                                    rootStore.viewStore.initCustomerPopBtn();
                                    fn_set_customer_pop(rootStore, "min1");
                                }
                                }
                                /><span>즉시</span></label>
                            <label
                            ><input type="radio" name="time" checked={(fn_get_customer_pop(rootStore, "min5") === "Y") ? true : ""}
                                onChange={event => {
                                    rootStore.layerStore.setChangeCstTime('5');
                                    rootStore.viewStore.initCustomerPopBtn();
                                    fn_set_customer_pop(rootStore, "min5");
                                }
                                }
                                /><span>5분</span></label>
                            <label
                            ><input type="radio" name="time" checked={(fn_get_customer_pop(rootStore, "min10") === "Y") ? true : ""}
                                onChange={event => {
                                    rootStore.layerStore.setChangeCstTime('10');
                                    rootStore.viewStore.initCustomerPopBtn();
                                    fn_set_customer_pop(rootStore, "min10");
                                }
                                }
                                /><span>10분</span></label>
                            <label
                            ><input type="radio" name="time" checked={(fn_get_customer_pop(rootStore, "min15") === "Y") ? true : ""}
                                onChange={event => {
                                    rootStore.layerStore.setChangeCstTime('15');
                                    rootStore.viewStore.initCustomerPopBtn();
                                    fn_set_customer_pop(rootStore, "min15");
                                }
                                }
                                /><span>15분</span></label>
                            <label
                            ><input type="radio" name="time" checked={(fn_get_customer_pop(rootStore, "min20") === "Y") ? true : ""}
                                onChange={event => {
                                    rootStore.layerStore.setChangeCstTime('20');
                                    rootStore.viewStore.initCustomerPopBtn();
                                    fn_set_customer_pop(rootStore, "min20");
                                }
                                }
                                /><span>20분</span></label>
                            <label
                            ><input type="radio" name="time" checked={(fn_get_customer_pop(rootStore, "min30") === "Y") ? true : ""}
                                onChange={event => {
                                    rootStore.layerStore.setChangeCstTime('30');
                                    rootStore.viewStore.initCustomerPopBtn();
                                    fn_set_customer_pop(rootStore, "min30");
                                }
                                }
                                /><span>30분</span></label>
                            <label><input type="radio" name="time" checked={(fn_get_customer_pop(rootStore, "min45") === "Y") ? true : ""}
                                onChange={event => {
                                    rootStore.layerStore.setChangeCstTime('45');
                                    rootStore.viewStore.initCustomerPopBtn();
                                    fn_set_customer_pop(rootStore, "min45");
                                }
                                }
                            /><span>45분</span></label>
                            <label
                            ><input type="radio" name="time" checked={(fn_get_customer_pop(rootStore, "min60") === "Y") ? true : ""}
                                onChange={event => {
                                    rootStore.layerStore.setChangeCstTime('60');
                                    rootStore.viewStore.initCustomerPopBtn();
                                    fn_set_customer_pop(rootStore, "min60");
                                }
                                }
                                /><span>60분</span></label>
                            <label
                            ><input type="radio" name="time" checked={(fn_get_customer_pop(rootStore, "min90") === "Y") ? true : ""}
                                onChange={event => {
                                    rootStore.layerStore.setChangeCstTime('90');
                                    rootStore.viewStore.initCustomerPopBtn();
                                    fn_set_customer_pop(rootStore, "min90");
                                }
                                }
                                /><span>90분</span></label>
                            <label
                            ><input type="radio" name="time" checked={(fn_get_customer_pop(rootStore, "min120") === "Y") ? true : ""}
                                onChange={event => {
                                    rootStore.layerStore.setChangeCstTime('120');
                                    rootStore.viewStore.initCustomerPopBtn();
                                    fn_set_customer_pop(rootStore, "min120");
                                }
                                }
                                /><span>120분</span></label>
                            <div className="wrap_full_btn">
                                <span className="f_l"><button className="btn_cancel"
                                    onClick={event => {
                                        rootStore.layerStore.setLayerAlertType("");
                                        layerStore.setLayerCstExpectTime(false)
                                    }}
                                >취소</button></span>
                                <span className="f_r"><button className="btn_submit"
                                    onClick={event => {
                                        rootStore.layerStore.setLayerAlertType("");
                                        fn_bridge_order_accept(rootStore, rootStore.viewStore.getOrderDetail.mobileOrderNo, rootStore.layerStore.getChangeCstTime, rootStore.viewStore.getOrderDetail.orderNo)
                                        //fn_change_step(rootStore, '200');
                                    }}
                                >확인</button></span>
                            </div>

                        </div>
                        <div className="btn_close btn_close_comm">
                            <button
                                onClick={event => {layerStore.setLayerCstExpectTime(false);rootStore.viewStore.initCustomerPopBtn();}}
                            ><span>닫기</span></button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CustomerExpectTimeView;